import { useEffect } from "react";
import { useApiQuery } from "../../../lib/useApiQuery.js";
import { feishuDepartmentsPath } from "../../../lib/api-paths.js";
import type { FeishuDepartmentsResponse } from "../../../lib/api-types.js";
import { FeishuDeptTree } from "../../OrganizationDetail/FeishuDeptTree.js";
import type { OnboardingStepProps } from "../types.js";

/**
 * Step 2 — 同步组织架构。复用 FeishuDeptTree（showMembers 模式：可展开看部门成员、标组长/已导入）。
 * 就绪判定：至少同步出一个部门。
 */
export function Step2DeptTree({
  org,
  onReadyChange,
}: OnboardingStepProps): JSX.Element {
  const { data } = useApiQuery<FeishuDepartmentsResponse>(
    feishuDepartmentsPath(org.code),
    [org.code],
  );

  useEffect(() => {
    if (data) onReadyChange(data.tree.length > 0);
  }, [data, onReadyChange]);

  return <FeishuDeptTree showMembers />;
}
